// extracted by mini-css-extract-plugin
export default {"Container":"extension_Container__aC1Ub","section-1":"extension_section-1__0YnAh","content":"extension_content__hNOKb","section-2":"extension_section-2__B09GH"};